// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4":"45d59916358c8cdb","695":"2c88bc9c2427a853"}[chunkId] + ".js";
};